import apiClient from '../utils/apiClient';

export async function getNotifications({ scope = 'all', unreadOnly = false, limit = 50, offset = 0 } = {}) {
  const response = await apiClient.get('/api/notifications', {
    params: { scope, unreadOnly, limit, offset },
  });
  return response.data?.notifications || [];
}

export async function getNotificationCounts() {
  const response = await apiClient.get('/api/notifications/counts');
  return response.data || { all: 0, schedule: 0, timesheets: 0 };
}

export async function markNotificationRead(notificationId) {
  const response = await apiClient.patch(`/api/notifications/${notificationId}/read`);
  return response.data;
}

export async function markAllNotificationsRead(scope = 'all') {
  const response = await apiClient.patch('/api/notifications/read-all', null, {
    params: { scope },
  });
  return response.data;
}
